import { render, staticRenderFns } from "./StepIdentification.vue?vue&type=template&id=3a7ca68a&"
import script from "./StepIdentification.vue?vue&type=script&lang=js&"
export * from "./StepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7ca68a')) {
      api.createRecord('3a7ca68a', component.options)
    } else {
      api.reload('3a7ca68a', component.options)
    }
    module.hot.accept("./StepIdentification.vue?vue&type=template&id=3a7ca68a&", function () {
      api.rerender('3a7ca68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/sharedSteps/StepIdentification.vue"
export default component.exports